import React from "react";
import logoUiwib from "images/logo-uiwib.png";
import wave1 from "images/pattern/wave-1.svg";
import dots1 from "images/pattern/dots-1.svg";
import box1 from "images/pattern/box-1.svg";
import { lang } from "constant/lang";

const HistorySection = () => {
  return (
    <div className="flex flex-col gap-12 mb-16 md:mb-32">
      <div
        className="inline-flex items-center bg-wce-yellow-light px-4 md:px-6 rounded-3xl z-10 py-2
          font-yesevaOne text-wce-pink-bright text-2xl md:text-6.5xl min-h-[48px] md:min-h-[80px] w-fit"
      >
        {lang.about.history.title}
      </div>
      <div className="flex flex-col-reverse md:flex-row gap-12">
        <div className="flex flex-col text-white text-sm md:text-lg gap-6 z-10">
          <div className="md:w-[85%] relative">
            <div>{lang.about.history.p1}</div>
            <div className="absolute right-0 bottom-0 translate-x-full">
              <img className="w-[86px] min-w-[86px]" src={box1} alt={"box1"} />
            </div>
          </div>
          <div className="md:w-[85%] self-center">{lang.about.history.p2}</div>
          <div className="md:w-[85%] relative self-end">
            <div>{lang.about.history.p3}</div>
            <div className="absolute -left-20 top-0 -translate-x-full">
              <img
                className="w-[128px] min-w-[128px]"
                src={box1}
                alt={"box1"}
              />
            </div>
          </div>
        </div>
        <div className="relative self-center">
          <div className="absolute -right-4 top-11 -translate-y-full">
            <img
              className="w-[110px] min-w-[110px]"
              src={dots1}
              alt={"dots1"}
            />
          </div>
          <div className="absolute -right-20 -bottom-6">
            <img className="w-[120px] min-w-[120px]" src={box1} alt={"box1"} />
          </div>
          <div className="absolute -right-6 bottom-4 translate-y-full">
            <img
              className="w-[70px] md:w-[140px] md:min-w-[140px]"
              src={wave1}
              alt={"wave1"}
            />
          </div>
          <div className="relative">
            <img
              className="w-[164px] md:w-[330px] md:min-w-[330px]"
              src={logoUiwib}
              alt={"UIWIB Logo"}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HistorySection;
